function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "upload_icon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grafill__Sumbission_4.Filer/lenker",
  transform: "translate(-370.000000, -292.000000)",
  fill: "#373737",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "filer_section",
  transform: "translate(130.000000, 153.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "upload_area",
  transform: "translate(2.000000, 55.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "upload_area_content",
  transform: "translate(155.000000, 85.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "upload_icon",
  transform: "translate(83.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Line-7",
  points: "33.646467 0.00380142961 33.9961986 -0.353532953 57.853533 22.9961986 57.5038014 23.353533"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line-7",
  transform: "translate(22.250000, 11.500000) scale(-1, 1) translate(-22.250000, -11.500000) ",
  points: "10.146467 0.00380142961 10.4961986 -0.353532953 34.353533 22.9961986 34.0038014 23.353533"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line-6",
  points: "34.25 -0.25 34.25 57.25 33.75 57.25 33.75 -0.25"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line",
  points: "67.75 34.25 67.75 68.25 67.25 68.25 67.25 34.25"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line-8",
  points: "67.75 67.75 67.75 68.25 0.25 68.25 0.25 67.75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line",
  points: "0.75 33.75 0.75 68.25 0.25 68.25 0.25 33.75"
})))))));

var SvgUploadIcon = function SvgUploadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "70px",
    viewBox: "0 0 68 70",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload_icon.50cccfab.svg";
export { ForwardRef as ReactComponent };